import { makeStyles } from '@mui/styles';

const usePhotoStyle = makeStyles(() => ({
  root: {
    margin: '15px 10px',
    padding: 0,
    borderRadius: 16,
    transition: 'transform .2s ease-out',
    '&:hover': {
      transform: 'scale(2)',
      zIndex: 100,
    },
    position: 'relative',
    boxShadow: '0 4px 8px 0 rgba(54, 56, 56, 0.815) !important',
  },
  rootMobile: {
    '&:hover': {
      transform: 'scale(1.2)',
      zIndex: 100,
    },
  },
  rootDark: {
    boxShadow: '0 4px 8px 0 rgba(240, 238, 238, 0.815) !important',
  },
  small: {
    gridRowEnd: 'span 20',
  },
  medium: {
    gridRowEnd: 'span 30',
  },
  large: {
    gridRowEnd: 'span 30',
  },
}));

export default usePhotoStyle;
